module.exports = __webpack_public_path__ + "img/sub_page_communication43.fb9637ff.png";